import CommonConstants from './common.constants';

const BASE_APP_ROUTE = '/';
const BASE_SCRIPTS_ROUTE = `${BASE_APP_ROUTE}scripts`;
const BASE_DNC_ROUTE = `${BASE_APP_ROUTE}dnc`;
const BASE_EMAILS_ROUTE = `${BASE_APP_ROUTE}email`;
const EMAIL_TEMPLATES_ROUTE = `${BASE_EMAILS_ROUTE}/templates`;
const BASE_REPORT_ROUTE = `${BASE_APP_ROUTE}report`;
const BASE_ACCOUNT_SETTINGS_ROUTE = `${BASE_APP_ROUTE}account-settings`;

const GLOBAL_ROUTES = {
  BASE: BASE_APP_ROUTE,
  LOGIN: `${BASE_APP_ROUTE}login`,
  LOGOUT: `${BASE_APP_ROUTE}logout`,
  SSO: `${BASE_APP_ROUTE}sso`,
};

const SCRIPTS_ROUTES = {
  BASE: BASE_SCRIPTS_ROUTE,
  ACTIVE: `${BASE_SCRIPTS_ROUTE}/active`,
  ARCHIVED: `${BASE_SCRIPTS_ROUTE}/archived`,
};

const SEARCH_PARAMS = {
  BASE: `?pageSize=${CommonConstants.INITIAL_ROWS_PER_PAGE}&pageNo=${CommonConstants.INITIAL_PAGE_NO}&order=${CommonConstants.INITIAL_SORT_ORDER}&direction=${CommonConstants.INITIAL_SORT_DIRECTION}`,
  DNC: `?pageSize=${CommonConstants.INITIAL_ROWS_PER_PAGE}&pageNo=${CommonConstants.INITIAL_PAGE_NO}&order=${CommonConstants.INITIAL_DNC_SORT_ORDER}&direction=${CommonConstants.INITIAL_SORT_DIRECTION}`,
  USERS: `?pageSize=${CommonConstants.INITIAL_ROWS_PER_PAGE}&pageNo=${CommonConstants.INITIAL_PAGE_NO}&order=${CommonConstants.INITIAL_USERS_SORT_ORDER}&direction=${CommonConstants.INITIAL_USERS_SORT_DIRECTION}`,
};

const DNC_ROUTES = {
  BASE: BASE_DNC_ROUTE,
};

const EMAILS_ROUTES = {
  BASE: BASE_EMAILS_ROUTE,
  TEMPLATES: `${EMAIL_TEMPLATES_ROUTE}`,
  ACTIVE: `${EMAIL_TEMPLATES_ROUTE}/active`,
  ARCHIVED: `${EMAIL_TEMPLATES_ROUTE}/archived`,
  SMTP: `${BASE_EMAILS_ROUTE}/smtp`,
  SMTP_VERIFICATION: `${BASE_EMAILS_ROUTE}/smtp/verify/:token`,
};

const ADMIN_ROUTES = {
  USERS: '/users',
  REPORT: '/admin-report',
  GLOBAL_DNC: '/global-dnc',
  USER_CALLER_IDS: '/my-numbers',
  GLOBAL_SCRIPTS: '/global-scripts',
  GLOBAL_EMAILS: '/global-emails',
  GROUPS: '/groups',
  ADMIN_SETTINGS: '/admin-settings',
  CALLER_IDS_CHECKER: '/caller-ids-checker',
};

const REPORT_ROUTES = {
  BASE: BASE_REPORT_ROUTE,
};

const ACCOUNT_SETTINGS_ROUTES = {
  BASE: BASE_ACCOUNT_SETTINGS_ROUTE,
};

export default {
  GLOBAL_ROUTES,
  SCRIPTS_ROUTES,
  SEARCH_PARAMS,
  DNC_ROUTES,
  EMAILS_ROUTES,
  ADMIN_ROUTES,
  REPORT_ROUTES,
  ACCOUNT_SETTINGS_ROUTES,
};
